import { render, staticRenderFns } from "./show_social_networks.vue?vue&type=template&id=317dad8f"
import script from "./show_social_networks.vue?vue&type=script&lang=js"
export * from "./show_social_networks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports